import { db } from '@/main'
import helpers from '@/helpers.js'
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";

import { 
  collection,
  startAfter,
  query,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";

export default {
  name: "groups",
  components: {
    Multiselect,
  },
  props: [],
  data() {
    return {
      view: {
        loadingResources: false,
      },
      filter: {
        tags: null,
        string: null,
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters.userData;
    },
    org() {
      return this.$store.getters.activeOrg;
    },
    storeGroups () {
      return this.$store.getters.docFiles(this.filter, "groups")
    },
    stateGroups () {
      return this.$store.state.groups;
    },
    groupsTags() {
      return this.$store.getters.groupsTags;
    },
  },
  watch: {

  },
  mounted() {
    console.log("Groups mounted:", this.storeGroups);
    if (this.$route.query.tags) {
      this.filter.tags = this.$route.query.tags.split(",") || null;
    }
  },
  methods: {
    tagSearchInput() {
      console.log("tag search changed, now:", this.filter.tags);
      // filter resourceDirectory for resources that contain the tags in the input

      // update tags in query param
      const query = Object.assign({}, this.$route.query);

      query.tags = this.filter.tags.join(",");

      if (!this.filter.tags.length) {
        delete query.tags;
        this.filter.tags = null;
      }

      console.log("query:", query);

      this.$router.push({ query });

    },
    async visibilityChanged(isVisible, entry, group, index) {
      if (isVisible && !group.loadedData) {
        console.log("we need to hydrate:", group);
        let storeGroup = this.$store.getters.group(group.id);

        if (!storeGroup || !storeGroup.loadedData) {
          storeGroup = await this.$store.dispatch("fetchDocData", {
            id: group.id,
            collection: "groups",
          });
        }

        this.$set(group, storeGroup);

      }
    },
  },
};
